import { render, staticRenderFns } from "./YhContractAdd.vue?vue&type=template&id=5662f265&scoped=true"
import script from "./YhContractAdd.vue?vue&type=script&lang=js"
export * from "./YhContractAdd.vue?vue&type=script&lang=js"
import style0 from "./YhContractAdd.vue?vue&type=style&index=0&id=5662f265&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5662f265",
  null
  
)

export default component.exports